var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTettiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 158,
    viewBox: "0 0 205 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_329)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.65 99.3894H190.558V132.149H176.065H176.05V98.9067L106.536 53.1926L80.5363 69.9941H54.1754L106.159 34.943L202.65 99.3894Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6968 109.555H7.70935V102.949H36.8401V109.555H26.896V132.409H17.6968V109.555Z",
    fill: "#BA0932"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6914 125.968V132.409H45.5764V102.949H71.0911V109.39H54.6888V114.354H69.1385V120.579H54.6888V125.968H71.6914Z",
    fill: "#BA0932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0339 109.555H79.0392V102.949H108.17V109.555H98.2331V132.409H89.0339V109.555Z",
    fill: "#BA0932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.305 109.555H114.317V102.949H143.448V109.555H133.504V132.409H124.305V109.555Z",
    fill: "#BA0932"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.391 102.949H152.192V132.409H161.391V102.949Z",
    fill: "#BA0932"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.092 34.345L104.113 6.97418L66.7085 30.9732V14.1069H51.2319V41.3336L7.70935 70.9595H34.063L103.462 24.9068L104.756 25.0653L118.7 34.345H144.092Z",
    fill: "#BA0932"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 205,
    height: 158
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205 0H0V158H205V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9144 78.206V97.9686H25.0795V89.1572H13.689V97.9686H10.854V78.206H13.689V86.7004H25.0795V78.206H27.9144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.069 88.0837C34.069 82.2983 38.5456 77.9755 44.6422 77.9755C50.7389 77.9755 55.1577 82.2695 55.1577 88.0837C55.1577 93.8979 50.681 98.192 44.6422 98.192C38.6035 98.192 34.069 93.8763 34.069 88.0837ZM52.3155 88.0837C52.3155 83.7104 49.0249 80.4899 44.635 80.4899C40.2452 80.4899 36.8967 83.7104 36.8967 88.0837C36.8967 92.457 40.1801 95.6775 44.635 95.6775C49.09 95.6775 52.3155 92.457 52.3155 88.0837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1313 89.4382V78.206H63.9663V89.3301C63.9663 93.7034 65.9768 95.6847 69.5495 95.6847C73.1221 95.6847 75.1615 93.7106 75.1615 89.3301V78.206H77.9097V89.4382C77.9097 95.1732 74.7638 98.1919 69.5205 98.1919C64.2773 98.1919 61.1313 95.1732 61.1313 89.4382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.717 95.7063L84.7657 93.5017C86.241 94.8274 88.765 95.7856 91.3107 95.7856C94.7387 95.7856 96.214 94.4599 96.214 92.738C96.214 87.9108 84.2016 90.9584 84.2016 83.6168C84.2016 80.5692 86.5809 77.9683 91.7953 77.9683C94.1167 77.9683 96.525 78.5879 98.1739 79.719L97.241 81.9813C95.5125 80.879 93.5599 80.3746 91.8025 80.3746C88.4323 80.3746 86.9859 81.7868 86.9859 83.5087C86.9859 88.3359 98.9984 85.3171 98.9984 92.5723C98.9984 95.5911 96.5612 98.192 91.3179 98.192C88.2877 98.192 85.3081 97.1761 83.7243 95.7063",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.335 95.5118V97.9686H104.943V78.206H118.944V80.6628H107.778V86.7292H117.722V89.1284H107.778V95.5118H119.335Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTettiWhite);
export default __webpack_public_path__ + "static/media/logo-tetti-white.679db19199df483d5bedd94429c6fcce.svg";
export { ForwardRef as ReactComponent };